import AuthReducer from "./AuthReducer";
import { createContext, useReducer } from "react";
import { useEffect } from "react";
import React from 'react'


const INITIAL_STATE = {
    user: JSON.parse(localStorage.getItem("user")) || null,
};


export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider = ({ children }) => {
    const [state,dispatch] = useReducer(AuthReducer, INITIAL_STATE)

    useEffect(()=>{
        localStorage.setItem("user", JSON.stringify(state.user))
},[state.user])

    return (
        <AuthContext.Provider value={{ user: state.user, dispatch }}>
        { children }
        </AuthContext.Provider>
    )
}